var generateComponentTheme = function generateComponentTheme() {
  return {
    cardMinWidth: '500px'
  };
};
export default generateComponentTheme;